import clientUtil from './clientUtil';

// 获取用户状态
async function getUserStatus() {
  const appVersion = await new Promise((resolve) => {
    clientUtil.getHeaders(res => {
      console.log('获取客户端版本里', res["YX-Version"] || 820);
      resolve(res["YX-Version"] || 820)
    });
    // 端外访问调不通客户端接口，3秒后接口没有调通默认在端外
    setTimeout(() => {
      resolve(0);
    }, 3000)
  })
  console.log('获取客户端版本外', appVersion);
  let userState = '';
  if (appVersion > 820) {
    userState = await new Promise((resolve) => {
      clientUtil.getUserState(res => {
        console.log('获取用户状态里', res);
        resolve(res)
      })
    })
    console.log('获取用户状态外', userState);
  }
  return {
    appVersion, userState
  }
}

// 是否测试环境
export function isTestEnv() {
  const testHosts = [
    'localhost',
    'haofenqi-api-server.test.weicai.com.cn',
    'haofenqi-mapi-enva.test.weicai.com.cn',
    'haofenqi-mapi-envb.test.weicai.com.cn',
    'haofenqi-mapi-envc.test.weicai.com.cn',
    'haofenqi-mapi-envd.test.weicai.com.cn',
  ];
  const host = location.hostname;
  const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (reg.test(host) || testHosts.some(item => item === host)) {
    return true;
  }
  return false;
}

// 埋点上报url
export function getSensorsServerUrl(isTest) {
  const serverUrl = isTest ? 'https://sensors.haohuan.com/sa?project=default' : 'https://sensors.haohuan.com/sa?project=production'
  console.log(`神策配置serverUrl:${serverUrl}`);
  return serverUrl;
}

// 是否微信
export function isWechat() {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
    return true;
  }
  return false;
}

// 埋点上报
export async function sensorsBuriedPoint(type, data, needUserstate = true) {
  console.log('是否需要用户状态', needUserstate);
  if (needUserstate) {
    const { appVersion, userState } = await getUserStatus();
    if (appVersion > 820) {
      data.HfqUserstate = userState
    }
  }
  console.log('开始打点');
  try {
    // eslint-disable-next-line
    sensors.track(type, data);
  } catch (e) {
    console.log(`埋点上报异常：${e}`)
  }
}

// 获取地址栏参数
export function getUrlParam(name) {
  const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.href);
  if (results == null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
}

// 根据id数组排序商品数组
export function goodsListSort(idArr, goodsArr) {
  var list = [];
  for (var item of idArr) {
    for (var gItem of goodsArr) {
      if (item == gItem.productCode) {
        list.push(gItem)
      }
    }
  }
  return list;
}

// 判断是否是iphonex
export function isIphoneX() {
  if (/iphone/gi.test(window.navigator.userAgent)) {
    /* iPhone X、iPhone XS */
    const x = window.screen.width === 375 && window.screen.height === 812;
    /* iPhone XS Max */
    const xsMax = window.screen.width === 414 && window.screen.height === 896;
    /* iPhone XR */
    const xR = window.screen.width === 414 && window.screen.height === 896;
    if (x || xsMax || xR) {
      return true;
    }
    return false;
  }
  return false;
}

export function isIOS() {
	return !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

export function getIosVersion() {
	if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
		const version = navigator.userAgent.match(/OS ((\d+_?){2,3})\s/);
    if(version && version[1]){
      return version[1].split('_');
    }
	}
  return [0,0,0]
}

export function formatTimeStamp(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}年${month}月${day}日`;
}

